// deno-fmt-ignore-file
export class CreateError extends Error {
    constructor(type, message) {
        super(message);
        this.type = type;
    }
}
